var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpthub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65368 4.6611L10.3419 6.57242C11.1065 8.69373 12.777 10.3642 14.8983 11.1287L16.8096 11.817C16.9819 11.8796 16.9819 12.1238 16.8096 12.1855L14.8983 12.8738C12.777 13.6383 11.1065 15.3088 10.3419 17.4301L9.65368 19.3414C9.59111 19.5137 9.34684 19.5137 9.28513 19.3414L8.59688 17.4301C7.83235 15.3088 6.16186 13.6383 4.04054 12.8738L2.12921 12.1855C1.95693 12.123 1.95693 11.8787 2.12921 11.817L4.04054 11.1287C6.16186 10.3642 7.83235 8.69373 8.59688 6.57242L9.28513 4.6611C9.34684 4.48797 9.59111 4.48797 9.65368 4.6611Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65368 4.6611L10.3419 6.57242C11.1065 8.69373 12.777 10.3642 14.8983 11.1287L16.8096 11.817C16.9819 11.8796 16.9819 12.1238 16.8096 12.1855L14.8983 12.8738C12.777 13.6383 11.1065 15.3088 10.3419 17.4301L9.65368 19.3414C9.59111 19.5137 9.34684 19.5137 9.28513 19.3414L8.59688 17.4301C7.83235 15.3088 6.16186 13.6383 4.04054 12.8738L2.12921 12.1855C1.95693 12.123 1.95693 11.8787 2.12921 11.817L4.04054 11.1287C6.16186 10.3642 7.83235 8.69373 8.59688 6.57242L9.28513 4.6611C9.34684 4.48797 9.59111 4.48797 9.65368 4.6611Z",
    fill: "url(#paint0_linear_3501_47876)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.259 0.0662106L18.6079 1.03387C18.9953 2.10781 19.8412 2.95376 20.9152 3.34117L21.8829 3.69001C21.9703 3.72172 21.9703 3.84514 21.8829 3.87685L20.9152 4.22569C19.8412 4.6131 18.9953 5.45905 18.6079 6.53299L18.259 7.50065C18.2273 7.58808 18.1039 7.58808 18.0722 7.50065L17.7234 6.53299C17.3359 5.45905 16.49 4.6131 15.416 4.22569L14.4484 3.87685C14.361 3.84514 14.361 3.72172 14.4484 3.69001L15.416 3.34117C16.49 2.95376 17.3359 2.10781 17.7234 1.03387L18.0722 0.0662106C18.1039 -0.0220702 18.2282 -0.0220702 18.259 0.0662106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.259 0.0662106L18.6079 1.03387C18.9953 2.10781 19.8412 2.95376 20.9152 3.34117L21.8829 3.69001C21.9703 3.72172 21.9703 3.84514 21.8829 3.87685L20.9152 4.22569C19.8412 4.6131 18.9953 5.45905 18.6079 6.53299L18.259 7.50065C18.2273 7.58808 18.1039 7.58808 18.0722 7.50065L17.7234 6.53299C17.3359 5.45905 16.49 4.6131 15.416 4.22569L14.4484 3.87685C14.361 3.84514 14.361 3.72172 14.4484 3.69001L15.416 3.34117C16.49 2.95376 17.3359 2.10781 17.7234 1.03387L18.0722 0.0662106C18.1039 -0.0220702 18.2282 -0.0220702 18.259 0.0662106Z",
    fill: "url(#paint1_linear_3501_47876)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.259 16.4992L18.6079 17.4668C18.9953 18.5408 19.8412 19.3867 20.9152 19.7741L21.8829 20.123C21.9703 20.1547 21.9703 20.2781 21.8829 20.3098L20.9152 20.6586C19.8412 21.0461 18.9953 21.892 18.6079 22.9659L18.259 23.9336C18.2273 24.021 18.1039 24.021 18.0722 23.9336L17.7234 22.9659C17.3359 21.892 16.49 21.0461 15.416 20.6586L14.4484 20.3098C14.361 20.2781 14.361 20.1547 14.4484 20.123L15.416 19.7741C16.49 19.3867 17.3359 18.5408 17.7234 17.4668L18.0722 16.4992C18.1039 16.4117 18.2282 16.4117 18.259 16.4992Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.259 16.4992L18.6079 17.4668C18.9953 18.5408 19.8412 19.3867 20.9152 19.7741L21.8829 20.123C21.9703 20.1547 21.9703 20.2781 21.8829 20.3098L20.9152 20.6586C19.8412 21.0461 18.9953 21.892 18.6079 22.9659L18.259 23.9336C18.2273 24.021 18.1039 24.021 18.0722 23.9336L17.7234 22.9659C17.3359 21.892 16.49 21.0461 15.416 20.6586L14.4484 20.3098C14.361 20.2781 14.361 20.1547 14.4484 20.123L15.416 19.7741C16.49 19.3867 17.3359 18.5408 17.7234 17.4668L18.0722 16.4992C18.1039 16.4117 18.2282 16.4117 18.259 16.4992Z",
    fill: "url(#paint2_linear_3501_47876)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3501_47876",
    x1: 2.21341,
    y1: 5.09148,
    x2: 18.5183,
    y2: 7.31189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF307C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3501_47876",
    x1: 14.4909,
    y1: 0.283733,
    x2: 22.7484,
    y2: 1.40819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF307C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3501_47876",
    x1: 14.4909,
    y1: 16.7173,
    x2: 22.7483,
    y2: 17.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF307C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpthub);
export default __webpack_public_path__ + "static/media/gpthub.9037b5715c90f03a38c66e5dc40be986.svg";
export { ForwardRef as ReactComponent };